export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const SITE_KEY = process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY;
export const SECRET_KEY = process.env.REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY;
